import { useEffect } from "react"

import { useRootQuery } from "graphql/smart-queries/user"

import { useProductsDispatch, ProductActionEventType } from "shared/context/products"
import { isTestEnvironment } from "config/app"

function useUpdateProducts() {
  const { data } = useRootQuery()
  const { dispatch } = useProductsDispatch()

  useEffect(() => {
    if (!isTestEnvironment && data?.displayedProducts) {
      dispatch({
        event: ProductActionEventType.updateProductGroups,
        products: data.displayedProducts
      })
    }
  }, [data])
}

export default useUpdateProducts
